import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const PackageServices = () => {
  const [editMode, setEditMode] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
  const [startIndex, setStartIndex] = useState(0);
  const [ searchQuery,setSearchQuery] = useState('');
  const history = useHistory();
  const [packageList, setPackageList] = useState([]);
  const [packageName, setPackageName] = useState('');
  const [discount, setDiscount] = useState('');
  const [description, setDescription] = useState('');
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const { id } = useParams();
  const [idtodelete, setIdToDelete] = useState('');

  useEffect(() => {
    fetchcategoryMaster();
    fetchpackagecomboservice();
}, [currentPage]);


const fetchpackagecomboservice = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
        const response = await axios.get(`${var_api}/api/package-combo-services/get/${id}`, {
            headers: {
                'Authorization': `${token}`
            }
        });
        setPackageList(response.data);
        
        setIsLogin(false);
    } catch (error) {
      setPackageList([]);
        if (error.response && error.response.status === 401) {
          history.push('/signin');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.response?.data?.error || 'Something went wrong!',
            confirmButtonColor: '#007500',
          });
        }
    }
  };

const fetchcategoryMaster = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/category-master/get`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      setCategories(response.data);
      
      setIsLogin(false);
  } catch (error) {
    setCategories([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};

  const fetchsubcategories= async (selectedId) => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
        const response = await axios.get(`${var_api}/api/sub-category-master/services/${selectedId}`, {
            headers: {
                'Authorization': `${token}`
            }
        });
        setSubCategories(response.data);
        
        setIsLogin(false);
    } catch (error) {
      setSubCategories([]);
        if (error.response && error.response.status === 401) {
          history.push('/signin');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.response?.data?.error || 'Something went wrong!',
            confirmButtonColor: '#007500',
          });
        }
    }
  };


const validateForm = () => {
  const newErrors = {};

  if (!packageName) newErrors.title = 'Package Name is required';
  if (!discount) newErrors.value = 'Value is required';
  if (!description) newErrors.description = 'Description is required';

  return newErrors;
};


const createPackageservice = async () => {
    const selectedService = subCategories.find(service => service.id === parseInt(selectedSubCategory));

  // Check if a subcategory is selected and exists
  if (!selectedService) {
    console.error("No valid service selected.");
    return;
  }
  
    const token = localStorage.getItem('token');
    setIsLogin(true);
  
    // Create a JSON object instead of FormData
    const payload = {
        package_id: id, // or another identifier for the package
        service_id: selectedService.id, // Service ID from the selected service
        service_name: selectedService.service_name, // Service name from the selected service
        service_price: selectedService.service_price, // Service price from selected service or fallback
      };
  
    try {
      const response = await axios.post(`${var_api}/api/package-combo-services/post`, payload, {
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Package Service Created Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Package Service created successfully!');
      }
        fetchpackagecomboservice();
        resetForm();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };

  const handleOpenConfirmation = (employeeId) => {
    setIdToDelete(employeeId);
    setShow(true);
};
  
  const handleCloseConfirmation= ()=>{
    setShow(false)
  };
  const handleDelete = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
        await axios.delete(`${var_api}/api/package-combo-services/delete/${idtodelete}/${id}`, {
            headers: {
                'Authorization': `${token}`
            }
        });
        console.log('Package Service deleted successfully!');
        fetchpackagecomboservice();
        handleCloseConfirmation();
        setIsLogin(false);
    } catch (error) {
        console.error('Error deleting Package Service :', error);
        if (error.response && error.response.status === 401) {
            history.push('/signin');
        }
    }
};


  const resetForm = () => {
    setPackageName('');      
    setDiscount('');         
    setDescription('');      // Clear the description field
    setSelectedCategory(''); // Reset the selected category
    setSelectedSubCategory(''); // Reset the selected subcategory
    setSubCategories([]);    // Clear the list of subcategories if needed
    setEditMode(false);  // Assuming you set profile file
};

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };
  
  // Filter employees before applying pagination
  const filteredEmployees = Array.isArray(packageList) && packageList.filter(pack => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (pack.service_name && pack.service_name.toString().toLowerCase().includes(searchLower)) ||
      (pack.service_price && pack.service_price.toString().toLowerCase().includes(searchLower)) 
    );
  });
  
  // Apply pagination to the filtered list
  const paginatedFilteredEmployees = filteredEmployees.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page
  };

  const handleCategoryChange = (e) => {
    const selectedId = e.target.value;
    setSelectedCategory(selectedId);
    fetchsubcategories(selectedId); // Fetch subcategories based on selected category
    setSelectedSubCategory(''); // Reset the subcategory selection
  };
  

  const handleSubCategoryChange = (e) => {
    setSelectedSubCategory(e.target.value);
  };


    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       PACKAGE SERVICES
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
             <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
             <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
            <Card.Body>
                <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>{editMode ? 'Edit Package Services' : 'Create Package Services'}</h5>
                <Form onSubmit={(e) => e.preventDefault()}>
                <Form.Group controlId="formCategory" className="mt-3">
        <Form.Label>Category</Form.Label>
        <Form.Control
          as="select"
          value={selectedCategory}
          onChange={handleCategoryChange}
          required
        >
          <option value="">Select Category</option>
          {categories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.category_name}
            </option>
          ))}
        </Form.Control>
        {errors.category && <p style={{ color: 'red' }}>{errors.category}</p>}
      </Form.Group>

      <Form.Group controlId="formSubCategory" className="mt-3">
        <Form.Label>Service</Form.Label>
        <Form.Control
          as="select"
          value={selectedSubCategory}
          onChange={handleSubCategoryChange}
          required
          disabled={!selectedCategory}
        >
          <option value="">Select Service</option>
          {subCategories.map((subCategory) => (
            <option key={subCategory.id} value={subCategory.id}>
              {subCategory.service_name}
            </option>
          ))}
        </Form.Control>
        {errors.subCategory && <p style={{ color: 'red' }}>{errors.subCategory}</p>}
      </Form.Group>
                     <Button variant="primary" type="button" className="mt-3" 
                      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
                      onClick={createPackageservice} hidden={editMode}  // This will hide the Submit button when editMode is true
                        >
                    Add
                    </Button>{" "}
                    <Button variant="danger" type="button" className="mt-3" onClick={resetForm}>
                        Reset
                    </Button>
                </Form>
            </Card.Body>
        </Card>
</Col>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"62rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                 <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Package Service List  <span style={{float:"right", fontSize:"17px", color:"black", fontWeight:"bold"}}><Form.Control type="text" placeholder="Search..."  onChange={handleSearchInput}/></span> </h5>  

        <Table responsive className="mt-3">
          <thead>
            <tr>
              <th>S.No</th> 
              <th>Services Name</th>
              <th>Service Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
  {paginatedFilteredEmployees.length > 0 ? (
    paginatedFilteredEmployees.map((pack, index) => (
      <tr key={pack.id}>
        <td>{startIndex + index + 1}</td>
        <td>{pack.service_name}</td>
        <td>{pack.service_price}</td>
        <td>
            <Button variant="danger" className="m-1" onClick={() => handleOpenConfirmation(pack.id)}>
              <i className="bi bi-trash"></i>
            </Button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="4" className="text-center">No data available</td>
    </tr>
  )}
</tbody>
</Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredEmployees.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
        </div>
        <Modal
        show={show}
        onHide={handleCloseConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Delete ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={handleCloseConfirmation}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>
        </>
    )
}

export default PackageServices;